import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const iconMap: Record<string, string> = {
  'ri-user-smile-line': 'ri-user-smile-line',
  'ri-star-line': 'ri-star-line',
  'ri-message-2-line': 'ri-message-2-line',
  'ri-fire-line': 'ri-fire-line',
  'ri-thumb-up-line': 'ri-thumb-up-line',
};

export default function ChannelMatrixSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10">
          <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider">频道导航</p>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-1">
            探索<span className="text-primary-500">吃瓜</span>频道
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col p-6 rounded-lg bg-background-50 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-500 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">{cat.name}</h3>
              <div className="flex items-center justify-between mt-auto">
                <span className="text-xs text-foreground-500">{cat.count} 篇爆料</span>
                <span className="text-xs text-primary-500 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  进入频道 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}